import CalendarMonth from "@mui/icons-material/CalendarMonth";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ScheduleButton, type ScheduleButtonProps } from "./schedule-button";

export const ScheduleSpecificButton: FC<Omit<ScheduleButtonProps, "icon" | "title">> = (props) => {
  const { t } = useTranslation();

  return <ScheduleButton icon={<CalendarMonth />} title={t("Schedule send")} {...props} />;
};
